<script lang="ts">
	import { getTranslate } from "@utils/getTranslate.js";
	import { Currency } from "@core/schema/Currency.js";
	import { getCurrencySymbol } from "@core/utils/formatPrice.js";
	import { Cart } from "../../cart/Cart.svelte.js";
	import translations from "./CurrencySwitcher.translations.json" with { type: "json" };

	const translate = getTranslate(translations);
	const { huge }: { huge?: boolean } = $props();
</script>

<div
	role="radiogroup"
	aria-label={translate("orderCurrency")}
	class="border-fcrlightgray-300 rounded-full bg-fcrlightgray-200 border p-1 w-fit flex shrink-0"
>
	{#each Object.values(Currency) as currency (currency)}
		<button
			role="radio"
			type="button"
			aria-checked={Cart.currency === currency}
			class={[
				huge ? "h-12 px-4 text-sm/none" : "h-8 px-3 text-xs/none",
				"bg-transparent aria-checked:bg-fcrdarkgray transition-colors rounded-full font-medium",
			]}
			onclick={(): void => {
				Cart.saveOrderFields({ payment: { currency } });
			}}
		>
			<span class="text-black [[aria-checked='true']>&]:text-white transition-colors">{currency}</span>
			{#if huge}
				<span class="text-fcrgray [[aria-checked='true']>&]:text-fcrlightgray-200/60 transition-colors">
					{getCurrencySymbol(currency)}
				</span>
			{/if}
		</button>
	{/each}
</div>
